export default __webpack_public_path__ + "static/media/icon-facebook.5dd2aebf.svg";